module.exports = __webpack_public_path__ + "static/decorations-in-a-ruined-cemetery-acf1776643dab55a111b502aec36d810.jpg";